var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"thumbnail-preview ma-0",attrs:{"src":_vm.imageData}})
}
var staticRenderFns = []

export { render, staticRenderFns }